import ChangePasswordContainer from "../../../../Component/OtherPages/Authentication/ResetPassword/ResetPassword";

const ResetChangePassword = () => {  

  return (
    <div className="page-body">
      <ChangePasswordContainer />
    </div>
  );
};

export default ResetChangePassword;
